import { render } from "./moduleShopDetail.vue?vue&type=template&id=58533a1a&scoped=true"
import script from "./moduleShopDetail.vue?vue&type=script&lang=js"
export * from "./moduleShopDetail.vue?vue&type=script&lang=js"

import "./moduleShopDetail.vue?vue&type=style&index=0&id=58533a1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58533a1a"]])

export default __exports__